import { Routes } from '@angular/router';
import { RiskManagementComponent } from './pages/risk-management/risk-management.component';
import { JournalComponent } from './pages/journal/journal.component';
import { StatsComponent } from './pages/stats/stats.component';
import { AnalysesComponent } from './pages/analyses/analyses.component';
import { LoginComponent } from './pages/login/login.component';
import { ConfigurationComponent } from './pages/configuration/configuration.component';
import { TradesTrackerComponent } from './pages/trades-tracker/trades-tracker.component';
import { DailyJournalComponent } from './pages/daily-journal/daily-journal.component';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './services/auth.service';

const authGuard = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.isLoggedIn()) {
    return true;
  }
  return router.parseUrl('/login');
};

export const routes: Routes = [
  { path: '', redirectTo: 'journal', pathMatch: 'full' },
  { path: 'login', component: LoginComponent, title: 'Login' },
  { path: 'journal', component: JournalComponent, title: 'Tradingtagebuch', canActivate: [authGuard] },
  { path: 'tagebuch', component: DailyJournalComponent, title: 'Tagebuch', canActivate: [authGuard] },
  { path: 'risiko', component: RiskManagementComponent, title: 'Risiko & Money Management', canActivate: [authGuard] },
  { path: 'statistik', component: StatsComponent, title: 'Auswertung & Statistik', canActivate: [authGuard] },
  { path: 'trades-tracker', component: TradesTrackerComponent, title: 'Meine Trades Tracker', canActivate: [authGuard] },
  { path: 'analysen', component: AnalysesComponent, title: 'Analysen', canActivate: [authGuard] },
  { path: 'konfiguration', component: ConfigurationComponent, title: 'Konfiguration', canActivate: [authGuard] },
  { path: '**', redirectTo: 'journal' }
];
